import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme, MarketingStarIcon, MarketingMountainIcon } from '@spoiler-alert/ui-library';
import { StepCard } from './step-card';
import { PlainItem } from './plain-item';
import { ACTIVE_STEP } from '../../pages/offer-comparison/active-step-enums';

interface StepperProps {
  activeStep: ACTIVE_STEP;
  setActiveStep: (step: ACTIVE_STEP) => void;
}

const useStyles = createUseStyles({
  container: { display: 'flex' },
  nav: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    width: 218,
    flexShrink: 0,
  },
  divider: {
    height: 1,
    backgroundColor: Theme.borderColor,
    marginBottom: 8,
  },
  plainGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  plainHeader: {
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '16px',
    color: Theme.grey80,
    padding: '4px 12px',
  },
  content: {
    flex: 1,
    paddingLeft: 32,
  },
  contentHidden: {
    display: 'none',
  },
});

export function Stepper({ activeStep, setActiveStep }: StepperProps) {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.nav}>
        <StepCard
          icon={<MarketingStarIcon />}
          index={1}
          colorTheme="green"
          label={'Award Suggestions'}
          isActive={activeStep === ACTIVE_STEP.SUGGESTIONS}
          onClick={() => setActiveStep(ACTIVE_STEP.SUGGESTIONS)}
        />
        <StepCard
          icon={<MarketingMountainIcon />}
          index={2}
          colorTheme="teal"
          label={'Award Opportunities'}
          isActive={activeStep === ACTIVE_STEP.OPPORTUNITIES}
          onClick={() => setActiveStep(ACTIVE_STEP.OPPORTUNITIES)}
        />
        <div className={classes.plainGroup}>
          <div className={classes.divider} />
          <div className={classes.plainHeader}>NO SUGGESTIONS</div>
          <PlainItem
            label={'Active Lanes'}
            isActive={activeStep === ACTIVE_STEP.ACTIVE_LANES}
            onClick={() => setActiveStep(ACTIVE_STEP.ACTIVE_LANES)}
          />
          <PlainItem
            label={'Inactive Lanes'}
            isActive={activeStep === ACTIVE_STEP.INACTIVE_LANES}
            onClick={() => setActiveStep(ACTIVE_STEP.INACTIVE_LANES)}
          />
        </div>
      </div>
    </div>
  );
}
